import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border bg-background/80 backdrop-blur-md sticky top-0 z-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft size={16} />
            Volver
          </Link>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-indigo-500 to-violet-500 flex items-center justify-center">
              <span className="text-white font-bold text-sm">F</span>
            </div>
            <span className="text-lg font-bold text-foreground">Frappi</span>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 max-w-3xl">
        <h1 className="text-3xl font-bold text-foreground mb-2">Politica de Privacidad</h1>
        <p className="text-sm text-muted-foreground mb-8">Ultima actualizacion: 1 de abril de 2026</p>

        <div className="prose prose-neutral dark:prose-invert max-w-none space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">1. Introduccion</h2>
            <p className="text-muted-foreground leading-relaxed">
              Frappi (&quot;nosotros&quot;, &quot;nuestro&quot; o &quot;la aplicacion&quot;) se compromete a proteger la privacidad de nuestros usuarios. Esta Politica de Privacidad describe como recopilamos, usamos, almacenamos y protegemos tu informacion personal cuando utilizas nuestra aplicacion movil y servicios web.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">2. Informacion que Recopilamos</h2>

            <h3 className="text-lg font-medium text-foreground mt-4 mb-2">2.1 Informacion que proporcionas directamente</h3>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li>Nombre completo y correo electronico al crear tu cuenta</li>
              <li>Informacion de estudiantes (nombres, datos academicos) que agregas a la plataforma</li>
              <li>Tareas, calificaciones, eventos de calendario y planes de estudio que creas</li>
              <li>Imagenes que capturas con la camara para el escaneo con IA</li>
            </ul>

            <h3 className="text-lg font-medium text-foreground mt-4 mb-2">2.2 Informacion recopilada automaticamente</h3>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li>Identificador del dispositivo y tipo de sistema operativo</li>
              <li>Datos de uso de la aplicacion (funciones utilizadas, frecuencia)</li>
              <li>Token de notificaciones push (Expo Push Notifications)</li>
              <li>Informacion de suscripcion y compras a traves de Google Play</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">3. Uso de la Camara</h2>
            <p className="text-muted-foreground leading-relaxed">
              Frappi utiliza el permiso de camara de tu dispositivo exclusivamente para:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-1 mt-2">
              <li><strong>Escaneo de tareas:</strong> capturar imagenes de asignaciones escolares para extraer informacion mediante IA</li>
              <li><strong>Escaneo de calificaciones:</strong> capturar imagenes de boletas o reportes de notas</li>
              <li><strong>Escaneo de calendario:</strong> capturar imagenes de horarios o calendarios escolares</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-2">
              Las imagenes capturadas se procesan a traves de servicios de IA (Google Gemini) para extraer datos estructurados. Las imagenes se almacenan temporalmente en nuestros servidores durante el procesamiento y pueden ser eliminadas por el usuario en cualquier momento.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">4. Como Usamos tu Informacion</h2>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li>Proporcionar y mejorar los servicios de la aplicacion</li>
              <li>Procesar tus solicitudes de IA (escaneo de tareas, ayuda con deberes, planes de estudio)</li>
              <li>Gestionar tu cuenta y suscripcion</li>
              <li>Enviarte notificaciones sobre tareas pendientes y recordatorios</li>
              <li>Brindar soporte tecnico</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">5. Almacenamiento y Seguridad</h2>
            <p className="text-muted-foreground leading-relaxed">
              Tu informacion se almacena de forma segura en servidores de Cloudflare (D1 y R2). Utilizamos encriptacion en transito (HTTPS/TLS) y tokens JWT para proteger el acceso a tu cuenta. Las contrasenas se almacenan de forma cifrada y nunca son visibles en texto plano.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">6. Servicios de Terceros</h2>
            <p className="text-muted-foreground leading-relaxed">
              Utilizamos los siguientes servicios de terceros:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-1 mt-2">
              <li><strong>Google Gemini:</strong> procesamiento de imagenes e inteligencia artificial</li>
              <li><strong>Google Play Billing:</strong> procesamiento de pagos y suscripciones</li>
              <li><strong>Cloudflare:</strong> alojamiento y almacenamiento de datos</li>
              <li><strong>Expo:</strong> notificaciones push</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-2">
              Cada servicio opera bajo sus propias politicas de privacidad. No vendemos ni compartimos tu informacion personal con terceros para fines publicitarios.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">7. Tus Derechos</h2>
            <p className="text-muted-foreground leading-relaxed">Tienes derecho a:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-1 mt-2">
              <li>Acceder a toda tu informacion personal almacenada</li>
              <li>Solicitar la correccion de datos inexactos</li>
              <li>Solicitar la eliminacion de tu cuenta y todos tus datos</li>
              <li>Exportar tus datos en un formato legible</li>
              <li>Revocar permisos de la aplicacion en cualquier momento desde la configuracion de tu dispositivo</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">8. Menores de Edad</h2>
            <p className="text-muted-foreground leading-relaxed">
              Frappi esta disenada para ser utilizada por profesores y padres de familia. Los datos de estudiantes son ingresados y gestionados por adultos responsables. No recopilamos intencionalmente informacion directamente de menores de 13 anos.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">9. Cambios a esta Politica</h2>
            <p className="text-muted-foreground leading-relaxed">
              Podemos actualizar esta politica periodicamente. Te notificaremos de cualquier cambio significativo a traves de la aplicacion o por correo electronico. El uso continuado de Frappi despues de los cambios constituye tu aceptacion de la politica actualizada.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">10. Contacto</h2>
            <p className="text-muted-foreground leading-relaxed">
              Si tienes preguntas sobre esta Politica de Privacidad o deseas ejercer tus derechos, contactanos en:
            </p>
            <p className="text-muted-foreground mt-2">
              <strong>Email:</strong>{' '}
              <a href="mailto:hola@frappi.app" className="text-primary hover:underline">
                hola@frappi.app
              </a>
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-border py-8 mt-12">
        <div className="container mx-auto px-4 text-center text-sm text-muted-foreground">
          &copy; {new Date().getFullYear()} Frappi. Todos los derechos reservados.
        </div>
      </footer>
    </div>
  );
}
